import http from '../../Services/laravel.api';

export const NavService = {
  sendEst: (formdata) => http.post('/get-estimate', formdata),
  sendContact: (formdata) => http.post('/contact-us', formdata),
};
